export const getCdnBaseUrl = (): string => {
  return (
    // Attempt to determine CSR apps via window variables
    (typeof window !== 'undefined' && window.cdn?.url) ||
    // Attempt to determine SSR apps via env variables
    (typeof process !== 'undefined' && process?.env?.['CDN_ROOT_URL']) ||
    // Fallback to value interpolatable by Cash Frontend Service (likely SSG)
    '{{cdn.url}}'
  )
}

export const getCdnBaseImageUrl = (): string => {
  return (
    // Attempt to determine CSR apps via window variables, `imageUrl` could be missing
    (typeof window !== 'undefined' && (window.cdn?.imageUrl || window.cdn?.url)) ||
    // Attempt to determine SSR apps via env variables, SSR doesn't currently have an image-specifc CDN defined
    (typeof process !== 'undefined' && process?.env?.['CDN_ROOT_URL']) ||
    // Fallback to value interpolatable by Cash Frontend Service (likely SSG)
    '{{cdn.imageUrl}}'
  )
}

export const getCdnVersion = (): string => {
  // Attempt to determine CSR apps via window variables
  if (typeof window !== 'undefined' && window.cdn?.version) {
    return window.cdn.version
  }
  // Likely loading SSR, no version value available currently and fallback is not going to work
  if (typeof process !== 'undefined' && process?.env?.['CDN_ROOT_URL']) {
    throw new Error('CDN version could not be determined!')
  }
  // Fallback to value interpolatable by Cash Frontend Service (likely SSG)
  return '{{cdn.version}}'
}
